import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function AdminLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center px-6 pt-20">
            <div className="w-full max-w-md border border-white/10 bg-surface p-10">
                <div className="flex items-center gap-3">
                    <img src="/assets/camarca-logo.png" alt="Camarca Digital Designs logo" className="h-12 w-12 rounded-full" />
                    <div>
                        <p className="font-display text-lg font-bold">CAMARCA</p>
                        <p className="font-mono text-[10px] tracking-[0.3em] text-zinc-500">ADMIN LOGIN</p>
                    </div>
                </div>
                <form onSubmit={submit} className="mt-10 space-y-5">
                    <div>
                        <label htmlFor="admin-email" className="mb-2 block font-mono text-xs tracking-[0.2em] uppercase text-zinc-500">Email</label>
                        <input
                            id="admin-email"
                            type="email"
                            data-testid="admin-email-input"
                            className="w-full rounded-none border border-zinc-800 bg-void px-4 py-3.5 text-sm text-white outline-none transition-[border-color] duration-300 focus:border-neon"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="admin-password" className="mb-2 block font-mono text-xs tracking-[0.2em] uppercase text-zinc-500">Password</label>
                        <input
                            id="admin-password"
                            type="password"
                            data-testid="admin-password-input"
                            className="w-full rounded-none border border-zinc-800 bg-void px-4 py-3.5 text-sm text-white outline-none transition-[border-color] duration-300 focus:border-neon"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <p data-testid="admin-login-error" className="font-mono text-xs text-red-400">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="group flex w-full items-center justify-center gap-3 bg-neon px-6 py-3.5 font-mono text-xs font-medium tracking-[0.2em] uppercase text-void transition-shadow duration-300 hover:shadow-[0_0_25px_rgba(0,240,255,0.5)] disabled:opacity-60"
                    >
                        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : (
                            <>Sign In <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" /></>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}
